import { BluetoothAdapterProvider } from '@services/bluetooth/adapter/BluetoothAdapterProvider';

const bluetoothAdapter = BluetoothAdapterProvider.get();

/**
 * Client for making cross frame calls to bluetoothLowenergyService in ATBase.
 */
export class BluetoothLowEnergyService {
    // Public functions
    /**
     * Connects to the bluetooth low energy device.
     * @param config
     * @returns {*}
     */
    public static connectBle(config: any): Promise<any> {
        return bluetoothAdapter.connectBle(config);
    }

    /**
     * Disconnects from the bluetooth low energy device.
     * @param config
     * @returns {*}
     */
    public static disconnectBle(config: any): Promise<any> {
        return bluetoothAdapter.disconnectBle(config);
    }

    /**
     * Reads the characteristic value from the connected bluetooth low energy device.
     * @param config
     * @returns {*}
     */
    public static readCharacteristicBle(config: any): Promise<any> {
        return bluetoothAdapter.readCharacteristicBle(config);
    }

    /**
     * Writes the characteristic value data to the bluetooth low energy device.
     * @param config
     * @returns {*}
     */
    public static writeCharacteristicBle(config: any): Promise<any> {
        return bluetoothAdapter.writeCharacteristicBle(config);
    }
}
